module.exports = __webpack_public_path__ + "static/img/7.bf1f1305.gif";